'use client'

import { Skeleton } from '@/components/ui/skeleton'

interface ListSkeletonProps {
  rows?: number
}

/** The one loading pattern every table/list screen uses while its query is pending (standards §8). */
export function ListSkeleton({ rows = 5 }: ListSkeletonProps) {
  return (
    <div className="flex flex-col gap-2" aria-hidden>
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} className="h-12 w-full rounded-lg" />
      ))}
    </div>
  )
}
